// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const nl: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'Hoe te spelen',
  'howto.pieces.heading': 'De stukken',
  'howto.pieces.source': 'Bron',
  'howto.pieces.mirror': 'Spiegel',
  'howto.pieces.switch': 'Schakelaar',
  'howto.pieces.exit': 'Uitgang',
  'howto.pieces.wall': 'Muur',
  'howto.controls.heading': 'De besturing',
  'howto.controls.clickSlot.line1': 'Klik op een vak',
  'howto.controls.clickSlot.line2': 'plaats spiegel',
  'howto.controls.dragMirror.line1': 'Sleep de spiegel',
  'howto.controls.dragMirror.line2': 'draaien',
  'howto.controls.rightClick.line1': 'Rechtermuisknop',
  'howto.controls.rightClick.line2': 'verwijder spiegel',
  'howto.controls.hint': 'Muiswiel: fijne rotatie van 1°.   Tik op spiegel: rotatie van 15°.',
  'howto.objective.line1': 'Verlicht elke schakelaar — het slot van de uitgang springt open.',
  'howto.objective.line2': 'Klik daarna op de uitgang. Los het op met zo weinig mogelijk spiegels.',

  'howtoColor.title': 'Kleur en prisma’s',
  'howtoColor.pieces.heading': 'Nieuwe stukken',
  'howtoColor.pieces.prism': 'Prisma',
  'howtoColor.pieces.redSwitch': 'Rode schakelaar',
  'howtoColor.pieces.yellowSwitch': 'Gele schakelaar',
  'howtoColor.pieces.whiteSwitch': 'Witte schakelaar',
  'howtoColor.how.heading': 'Hoe ze werken',
  'howtoColor.how.line1': 'Een witte straal draagt tegelijk rood, groen en blauw licht.',
  'howtoColor.how.line2':
    'Een prisma splitst wit licht in drie gekleurde stralen langs zijn drie zijden.',
  'howtoColor.how.line3': 'Klik op een geplaatst prisma om zijn invoerzijde te draaien.',
  'howtoColor.switches.line1':
    'Schakelaars tonen gekleurde stippen — dat is de kleur die ze vragen.',
  'howtoColor.switches.line2':
    'Een gele schakelaar (rode + groene stippen) heeft beide kleuren tegelijk nodig.',
  'howtoColor.switches.line3':
    'Een witte schakelaar (alle drie) heeft rood, groen ÉN blauw tegelijk nodig.',

  'options.hints.label': 'Toon hulphoeken in puzzels',
  'options.hints.help':
    'Toont de hoek tussen de inkomende en gereflecteerde straal bij elke kaatsing.',

  'level.01-intro.title': 'Hallo, licht',
  'level.02-two-mirrors.title': 'Twee bochten',
  'level.03-corner.title': 'Muur in de weg',
  'level.04-two-targets.title': 'Twee doelen',
  'level.05-tight.title': 'Krap',
  'level.06-hello-color.title': 'Hallo, kleur',
  'level.07-pick-a-side.title': 'Kies een kant',
  'level.08-yellow.title': 'Geel',
  'level.09-magenta.title': 'Magenta',
  'level.10-spectrum.title': 'Spectrum',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'recht',
  'puzzle.hint.angleType.acute': 'scherp',
  'puzzle.hint.angleType.obtuse': 'stomp',
  'puzzle.hint.label': '{angle}°\n{type}',
};
